import MuxPlayer from '@mux/mux-player-react'
import { forwardRef } from 'react'

import type MuxPlayerElement from '@mux/mux-player'
import type { ComponentProps, ReactElement } from 'react'

type MuxPlayerProperties = ComponentProps<typeof MuxPlayer>

type MuxPlaybackPlayerProperties = Omit<MuxPlayerProperties, 'loop' | 'playbackId'> & {
  playbackId: string
  isLoop?: boolean
}

export const MuxPlaybackPlayer = forwardRef<MuxPlayerElement, MuxPlaybackPlayerProperties>(
  ({ playbackId, isLoop, ...properties }, reference): ReactElement => {
    /* --- Section 6: Render --- */
    return <MuxPlayer key={playbackId} ref={reference} playbackId={playbackId} loop={isLoop} {...properties} />
  }
)

MuxPlaybackPlayer.displayName = 'MuxPlaybackPlayer'
